<style lang="less" scoped>
@import "assets/less/icon.less";
div.top {
  position:fixed;
  width: 650px;
  height:106px;
  border-radius: 20px;
  background: linear-gradient( 229deg, #2C303F 0%, rgba(255,255,255,0.3) 100%);
  padding:20px 30px;
  margin-left: 20px;
  margin-top: 20px;
  z-index:10;
  display: flex;
    justify-content: space-between;
    align-items: start;
  div.top-element {
    font-size: 30px;
    color:#fff;
    line-height: 1.5;
    
    strong {
        display: inline-block;
        padding:10px 15px;
        background: rgba(51,254,194,0);
        border-radius: 13px;
        border: 1px solid rgba(255,255,255,0.6);
        border-radius: 50px;
        text-align: center;
        font-size: 28px;
        color:#fff;
    }
  }

  div.top-desk {
    background:url("../../../src/assets/images/login/addtodsk.png") no-repeat;
    width: 150px;
    height: 70px;
    background-size:100% 100%;
    color:#333;
    font-size: 28px;
    text-align: center;
    line-height: 1.1;
    padding:15px 30px;
    position: relative;
    i.icon-pointer {
        position: absolute;
        right:-30px;
        bottom:-50px;
        background:url("../../../src/assets/images/login/pointer.png") no-repeat;
        background-size:100% 100%;
        width:88px;
        height:76px;
    }
  }
}

div.content {
    width: 750px;
    height: 434px;
    background:url("../../../src/assets/images/login/content-bg.png") no-repeat;
    background-size:100% 100%;
    padding-top: 150px;
  h1.title {
    display: flex;
    justify-content: start;
    align-items: center;
    padding:0 20px;
    margin: 30px 0;
    img {
        width: 60px;
        height: 60px;
        border-radius: 10px;
    }

    p.title-text {
        color:#fff;
        font-size: 28px;
        margin-left: 10px;
    }
  }

  h2.feature-tit {
    width:450px;
    height:25px;
    background:url("../../../src/assets/images/login/feature-ti-bg.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color:#333;
    font-size: 26px;
    line-height: 25px;
    font-weight: 700;
    padding:10px;
    margin-left: 30px;
  }

  p.feature-amount {
    font-size: 86px;
    padding-left: 30px;
    font-weight: 700;
    padding-top: 30px;
    color:#fff;
  }

  
}
p.feature-caption {
    width: 330px;
    height: 60px;
    padding:10px;
    background:url('../../../src/assets/images/login/fc-bg.png') no-repeat;
    background-size:100% 100%;
    font-size: 26px;
    color:#C6C7CF;
    line-height: 1.1;
    margin-left: 30px;
    margin-top: 10px;
  }

  div.form {
    background:url("../../../src/assets/images/login/form-bg.png") no-repeat;
    background-size: 100% 100%;
    width: 710px;
    margin:0 auto;
    height:594px;
    div.form-title {        
        font-size: 28px;
        text-align: center;
        padding-top: 50px;
        font-weight: bold;
        color:#33FEC2
    }

    div.form-container {      
      padding:10px 20px 0 20px;
      div.input-container {
        display: flex;
        justify-content: start;
        align-items: center;
        padding:20px;
        border:1px solid #9EA9C5;
        border-radius:60px;
        margin-top: 30px;
        background:#EEF8FE;
        width: 630px;
        div.prefix {
            margin-right: 30px;
            font-size: 28px;
            font-weight: 700;
        }

        div.input-content-container {    
          flex:1 0 auto; 
          padding-right: 20px;           
          input {
            display: block;
            height:50px;
            line-height: 50px;
            width: 99%;
            border:none;
            background:#EEF8FE;
            // padding-left: 20px;
            font-size: 28px;
            &::placeholder{
                font-size: 28px;
                color:#9EA9C5;
            }
          }
        }
        .get_code{
            flex:0 0 auto;
            display: block;
            width: 168px;
            height: 68px;
            background: #33FEC2;
            border-radius: 46px;
            text-align: center;
            line-height: 58px;
            color:#333;
            font-size: 28px;
            font-weight: 700;
            border:none;
        }
      }
    }

    div.btn-container {
      width: 650px;
      height: 108px;      
      margin:0 auto;
      button.btn-submit {
        background:url("../../../src/assets/images/login/btn-bg.png") no-repeat;
        background-size:100% 100%;
        border:none;
        display: block;
        width: 100%;
        text-align: center;
        color:#333;
        font-size: 30px;
        line-height: 108px;
      }
    }
  }

  div.features {
    div.features-list {
        display:flex;
        justify-content: space-around;
        flex-direction: row;
        flex-wrap: wrap;
      div.features-element {
        width: 290px;
        height: 160px;
        background: linear-gradient( 222deg, #2C303F 0%, #272936 100%);
        border-radius: 40px;
        padding:30px;
        margin-top: 30px;
        h3.feature-title {
            color:#fff;
            font-size: 26px;
            margin-bottom: 20px;
        }

        div.features-content {
          position:relative;
          p.feature-text {
            color:#5F5F5F;
            font-size: 24px;
            position:relative;
            z-index:1;
            line-height: 1.5;
          }

          div.feature-img {
            position:absolute;
            z-index:0;
            right:0;
            bottom:0px;
            &:nth-child(1){
                width: 84px;
                height: 98px;
            }
            &:nth-child(2){
                width: 92px;
                height: 92px;
            }
            &:nth-child(3){
                width: 128px;
                height: 90px;
            }
            &:nth-child(4){
                width: 142px;
                height: 112px;
            }
            img {
                width:100%;
                height: 100%;
            }
          }
        }
      }
    }
  }

  div.advantage-list {
    display: flex;
    justify-content: space-around;
    align-items: start;    
    background: linear-gradient( 222deg, #2C303F 0%, #272936 100%);
    border-radius: 100px 100px 20px 20px;
    margin:50px 20px;
    padding: 50px 0 20px 0;
    div.adv-element {
      width: 230px;
      div.adv-img {
        width: 114px;
        height: 114px;
        margin:0 auto;
        img {
            width:100%;
            height:100%;
        }        
      }
      p.adv-text {
           width: 200px;
           margin-top: 15px;
           font-size: 24px;
           color:#fff;
           text-align: center; 
           word-break: break-all;
           font-weight: 700;
           margin:15px auto;
        }
    }
  }
  .voice-code{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color:#33FEC2;
    margin:30px 0;
    .icon-mic{
        display: inline-block;
        width: 26px;
        height: 32px;
        background:url("../../../src/assets/images/login/icon-mic.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 20px;
    }
  }
div.process {
  width:710px;
  height:400px;
  background:url("../../../src/assets/images/login/p-bg.png") no-repeat;
  background-size:100% 100%;
  margin:0 auto;
  h2.process-title {
    font-size: 30px;
    color:#33FEC2;    
    padding-top: 50px;
    text-align: center;
  }

  ul.process-list {
    display: flex;
    justify-content: space-around;
    padding:0 60px;
    margin-top: 70px;
    li.process-element {
        width: 200px;
        &:nth-child(1){
            div.process-img{
                background:url("../../../src/assets/images/login/b1.png") no-repeat;
                background-size:100% 100%;
            }
        }
        &:nth-child(3){
            div.process-img{
                background:url("../../../src/assets/images/login/b2.png") no-repeat;
                background-size:100% 100%;
            }
        }
        &:nth-child(5){
            div.process-img{
                background:url("../../../src/assets/images/login/b3.png") no-repeat;
                background-size:100% 100%;
            }
        }
      div.process-img {
        width: 134px;
        height: 144px;
        margin:0 auto;
        img{
            width: 100%;
            height: 100%;
        }
      }
      .process-arrow{
        width: 26px;
        height: 22px;
        background:url("../../../src/assets/images/login/arrow-right.png") no-repeat;
        background-size:100% 100%;
        margin:0 auto;
        margin-top: 60px;
      }
      p.process-text {
        font-size: 18px;
        text-align: center;
        word-break: break-all;
        line-height: 1.5;
        margin-top: 10px;
        color:#fff;
      }
    }
  }
 
}
.van-swipe{
  overflow:inherit
}
div.reviews {  
    overflow:hidden;
  h2.r-title {
    width: 710px;
    height: 74px;
    background: linear-gradient( 90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 26%, rgba(255,255,255,0.4) 78%, rgba(255,255,255,0) 100%);
    font-size: 30px;
    line-height: 74px;
    color:#fff;
    text-align: center;
    font-weight: 700;
    margin:50px auto;
  }
  div.reviews-wrapper{
    width:750px;
    overflow-x:scroll
  }
  div.reviews-container {    
    margin: 0 0 50px 0;
    div.re-wrapper{
        padding-right: 30px;
        background:transparent;
    }
    div.revicew-element {
      float:left;
      width: 555px;
      height:324px;
      background: linear-gradient( 222deg, #2C303F 0%, #272936 100%);
      border-radius: 40px;
      padding: 0 20px;
      
      margin-left: 30px;
      div.r-top {
        // overflow:hidden;
        height:70px;
        padding-left: 150px;
        padding-top: 20px;
        div.avatar {
          width: 100px;
          height: 100px;
          margin-right: 20px;
          position:absolute;
          top:-30px;
          left:70px;
            &.m1{
              background:url("../../../src/assets/images/login/m1.png") no-repeat;
              background-size:100% 100%;
            }
            &.m2{
              background:url("../../../src/assets/images/login/m2.png") no-repeat;
              background-size:100% 100%;
            }
            &.m3{
              background:url("../../../src/assets/images/login/m3.png") no-repeat;
              background-size:100% 100%;
            }
            &.m4{
              background:url("../../../src/assets/images/login/m4.png") no-repeat;
              background-size:100% 100%;
            }
            &.f1{
              background:url("../../../src/assets/images/login/f1.png") no-repeat;
              background-size:100% 100%;
            }
            &.f2{
              background:url("../../../src/assets/images/login/f2.png") no-repeat;
              background-size:100% 100%;
            }
        }
        
        p.username {
          float:left;
          font-size: 24px;
          height:30px;
          line-height: 30px;
          color:#fff;
        }

        p.date {
          float:right;
          height:30px;
          line-height: 30px;
          font-size: 20px;
          color:#5F5F5F;
        }
      }

      div.stars {
        overflow:hidden;
        margin-bottom: 20px;
        div.star-element {
          float:left;
          width: 40px;
          height: 38px;
          background:url("../../../src/assets/images/login/star.png") no-repeat;
          background-size:100% 100%;
        }
      }

      div.user-reviews {
        font-size: 20px;
        line-height: 1.5;
        color:#fff;
      }
    }
  }
  .indicator-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  .custom-indicator{
    width:20px;
    height:20px;
    border-radius: 20px;
    background:#fff;
    margin-right: 15px;
    transition: all .3s;
    &.active{
        width:30px;
        background:#666;
    }
  }
  
}
</style>
<template>
    <div style="background:#1E1E3C;">    
        <div class="top" @click="toDownload">
            <div class="top-element">
                Add to desktop to unlock loan limit up to <strong>₹300000</strong>
            </div>
            <div class="top-desk">
                Add to
                Desktop
                <i class="icon-pointer"></i>
            </div>
        </div>    

        <div class="content">            
            <h1 class="title">
                <img src="../../../src/assets/images/logo.png" alt="ivmCredit">
                <p class="title-text">ivmCredit</p>
            </h1>
            <h2 class="feature-tit">
                With a maximum loan amount of
            </h2>
            <p class="feature-amount">
                ₹100000
            </p>
            <p class="feature-caption">
                you can easily meet your financial needs!
            </p>            
        </div>
        <div class="form">
                <div class="form-title">
                    Personal loan Apply online directly
                </div>
                <div class="form-container">                    
                    <div class="input-container">
                        <div class="prefix">+91</div>
                        <div class="input-content-container">
                            <input type="tel" v-model="obj.phone" placeholder="Please enter your phone number" @input="phoneInput">
                        </div>
                    </div>                    
                </div>
                <div class="form-container">                    
                    <div class="input-container">                            
                        <div class="input-content-container">
                            <input type="tel" v-model="obj.code" placeholder="Verification code" @input="codeInput">
                        </div>
                        <button class="get_code" @click="sendCodeFn">{{ code_text }}</button>
                    </div>
                    <div class="error" v-show='obj.is_error'>
                        <i class="icon icon-exclaim"></i> 
                        <p class="error-text" v-text="obj.error_text"></p>
                    </div>                
                </div> 
                <div class="voice-code" @click="sendVoiceCode">
                    <i class="icon-mic"></i>
                    Voice call verification
                </div>                 
                <div class="btn-container" @click="submit">
                    <button class="btn-submit" :class="{'active':btn_active}" >
                        Apply Now
                    </button>        
                </div>                  
            </div>
        <div class="features">
            <div class="features-list">
                <div class="features-element">
                    <h3 class="feature-title">Affordable Housing Loan</h3>
                    <div class="features-content">
                        <p class="feature-text">Only Simple Certification,Approval within 10Minutes</p>
                        <div class="feature-img"><img src="../../../src/assets/images/login/a1.png" alt=""></div>
                    </div>
                </div>
                <div class="features-element">
                    <h3 class="feature-title">Education Loan</h3>
                    <div class="features-content">
                        <p class="feature-text">Loan Terms Up to 6 Years, EaseYour
                            Repayment Burden</p>
                        <div class="feature-img"><img src="../../../src/assets/images/login/a2.png" alt=""></div>
                    </div>
                </div>
                <div class="features-element">
                    <h3 class="feature-title">Travel Loan</h3>
                    <div class="features-content">
                        <p class="feature-text">Borrow Anytime, Anywhere,QuickApproval in 5 Minutes</p>
                        <div class="feature-img"><img src="../../../src/assets/images/login/a3.png" alt=""></div>
                    </div>
                </div>
                <div class="features-element">
                    <h3 class="feature-title">Used Car Loan</h3>
                    <div class="features-content">
                        <p class="feature-text">Secure Your Desired Vehicle.Up to95% Financing Available</p>
                        <div class="feature-img"><img src="../../../src/assets/images/login/a4.png" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="advantage-list">
            <div class="adv-element">
                <div class="adv-img">
                    <img src="../../../src/assets/images/login/c1.png" alt="">                                                
                </div>
                <p class="adv-text">Fast approval</p>
            </div>
            <div class="adv-element">
                <div class="adv-img">
                    <img src="../../../src/assets/images/login/c2.png" alt="">                                                
                </div>
                <p class="adv-text">Fast loan</p>
            </div>
            <div class="adv-element">
                <div class="adv-img">
                    <img src="../../../src/assets/images/login/c3.png" alt="">                        
                </div>
                <p class="adv-text">Compliance and safety</p>
            </div>
        </div> 
        <div class="process">
            <h2 class="process-title">How to Get a Personal Loan</h2>
            <ul class="process-list">
                <li class="process-element">
                    <div class="process-img"></div>
                    <p class="process-text">Fill in your personal
                        information</p>
                </li>
                <li class="process-element">
                    <div class="process-arrow"></div>
                </li>
                <li class="process-element">
                    <div class="process-img"></div>
                    <p class="process-text">Submit loan application</p>
                </li>
                <li class="process-element">
                    <div class="process-arrow"></div>
                </li>
                <li class="process-element">
                    <div class="process-img"></div>
                    <p class="process-text">Receive loan</p>
                </li>
            </ul>
        </div>
        <div class="reviews-wrapper">
            <div class="reviews">
                <h2 class="r-title">
                    More user reviews
                </h2>                
                <div class="reviews-container">
                    <van-swipe indicator-color="white" :width="width" show-indicators :autoplay="3000">
                        <van-swipe-item  v-for="(element,ind) in reviews" :key="ind">
                            <div class="re-wrapper">
                                <div class="revicew-element">
                                    <div class="r-top">
                                        <div class="avatar" :class="element.pic"></div>
                                        <p class="username" v-text="element.name"></p>
                                        <p class="date" v-text="element.date"></p>
                                    </div>
                                    <div class="stars">
                                        <div class="star-element" v-for="(ele,ind2) in element.star" :key="ind2"></div>
                                    </div>
                                    <div class="user-reviews" v-text="element.text"></div>
                                </div>
                            </div>                            
                        </van-swipe-item>
                        <template #indicator="{ active, total }">
                            <div class="indicator-wrapper">                                
                                <div class="custom-indicator" v-for="ind in total" :key="ind" :class="{'active': active+1 == ind}" ></div>
                            </div>                            
                        </template>
                    </van-swipe>
                </div>
            </div>  
        </div>                
    </div>    
</template>

<script>
import { reactive, computed, ref,  getCurrentInstance, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { sendCode } from "@api/index"
import { voiceCode } from '../../../api'
import { useLoading } from 'vue-loading-overlay'
export default {         
    setup() {
        // const analytics = getAnalytics()
        const router = useRouter()
        const route = router.currentRoute
        const store = useStore()
        const secondRef = ref()
        const proxy  = getCurrentInstance().proxy
        const $loading = useLoading()
        const reviews = ref([
            {
                name:"Aarav Sharma",
                star:[1,1,1,1,1],
                text:"This app made getting a loan so simple. Fast approval, clear terms, and great customer support. I recommend it to anyone who needs quick financial help. Very reliable and efficient!",
                pic: "m1",
                date:"2025-01-22"
            },
            {
                name:"Viraj Patel",
                star:[1,1,1,1,1],
                text:"I’ve used several loan apps, but this one is by far the best. Quick approval, easy process, and low interest rates. It’s exactly what I needed. Highly recommend to others in need.",
                pic: "m2",
                date:"2025-01-22"
            },
            {
                name:"Priya Kapoor",
                star:[1,1,1,1,1],
                text:"Fantastic experience! The loan process was smooth, fast, and hassle-free. I got approved in minutes, and the rates were fair. Definitely my go-to app for financial help now.",
                pic: "f1",
                date:"2025-01-22"
            },
            {
                name:"Rajesh Kumar",
                star:[1,1,1,1,1],
                text:"I was in urgent need of funds, and this app delivered fast. The loan approval was instant, the process was easy, and the rates are great. Definitely recommend it for quick financial support.",
                pic: "m3",
                date:"2025-01-22"
            },
            {
                name:"Aarav Sharma",
                star:[1,1,1,1,1],
                text:"This app saved me when I needed money urgently. Quick approval, easy application, and low interest rates. It’s perfect for anyone looking for a hassle-free loan experience. Highly recommend!",
                pic: "m4",
                date:"2025-01-22"
            },
            {
                name:"Sita Sharma",
                star:[1,1,1,1,1],
                text:"I had a great experience with this loan app. The process was simple, approval was fast, and the rates are super affordable. I’m definitely going to use it again whenever I need funds.",
                pic: "f2",
                date:"2025-01-22"
            },
        ])
        const width = ref(0)
        width.value = document.body.clientWidth / 750 * 620
        const obj = reactive({
            checked: true,
            is_error: false,
            phone: '',
            error_text: '',            
            state: 0   ,
            code: '',
            clicked: false,
        })       
        onMounted(()=>{
            document.body.style.background = "#02E6E4"
        })
        const code_text = ref("Send") 
        const code_clicked = ref(false) 
        const btn_text = computed(()=>{
            if(obj.state == 0) {
                return 'Send OTP'
            } else {
                return 'Next'
            }
        })
        const btn_active = computed(()=>{
            return (obj.phone.length == 10 & obj.checked  & obj.code.length == 4)
        })        
        let to = 0
        const sendCodeFn = async () => {
            if (!obj.checked) {
                obj.is_error = true
                obj.error_text = 'Please agree with Loan Guarantee Argreement.'
            } else {
                
                if(code_clicked.value)return
                code_clicked.value = true
                if(obj.phone.length != 10) {
                    proxy.$toast.show("Please Enter correct your phone number")
                    code_clicked.value = false
                    return 
                }
                const loader = $loading.show({
                    container: null
                }) 
                let data = await sendCode({
                    phone: "91"+obj.phone
                })
                loader.hide()
                if(data.code == 0) {
                    obj.secs = 60
                    to = setInterval(()=>{                    
                        code_text.value = `${--obj.secs}s`
                        if(obj.secs<=0){
                            clearInterval(to)
                            code_text.value = 'resend'
                            code_clicked.value = false
                        }
                    },1000)
                    // logEvent(analytics, 'register_send_sms')
                } else {
                    code_clicked.value = false
                    obj.is_error = true
                    obj.error_text = data.msg
                }
            }
        }
        const phoneInput = () => {
            if(/D+/.test(obj.phone) | obj.phone.length > 10) {                
                obj.phone = obj.phone.substring(0, obj.phone.length - 1)                
            }            
        } 
        const codeInput = () => {
            if(/\D+/.test(obj.code) | obj.code.length > 4) {                
                obj.code = obj.code.substring(0, obj.code.length - 1)                
            }            
        } 
        
        const submit = async () => {
            if(obj.clicked) return 
            if(obj.phone < 10) {
                proxy.$toast.show("Please Enter correct your phone number")
                obj.clicked = false
                return 
            } 
            if(obj.code == '') {
                proxy.$toast.show("Please enter OTP Code")
                obj.clicked = false
                return 
            } 
            obj.clicked = true            
            store.dispatch('login',{
                phone:obj.phone,
                code:obj.code
            }).then((resp)=>{
                // logEvent(analytics, 'register_logined')
                obj.clicked = false
                if(resp.isRegister == 1) {
                    window.fbq('track', 'CompleteRegistration');
                }
                console.log(route)
                if(route.value.query.redirect) {
                    router.replace({
                        path:route.value.query.redirect
                    })        
                } else {
                    router.replace({
                        path:'/'
                    })
                }           
                
            }).catch((msg)=>{   
                obj.clicked = false                 
                proxy.$toast.show(msg)
            })
            
        }
        
        const toggleCheck = () => {
            obj.checked = !obj.checked            
        }       
        const setPhone = (phone) => {
            obj.phone = phone
        }
        const setCode = (code) => {
            obj.code = code
        }
        const changeState = (state) => {
            obj.state = state
        }
        const back = () => {
           changeState(0)
        }
        const sendVoiceCode = async () => {
            if(obj.phone.length != 10) {
                proxy.$toast.show("Please Enter correct your phone number")
                return
            }
            const loader = $loading.show({
                container: null
            }) 
            
            let data = await voiceCode({
                phone: "91"+obj.phone,
                type:"1"
            })
            loader.hide()
            if(data.code == '0') {
                proxy.$toast.show(data.data.msg)
            } else {
                proxy.$toast.show(data.msg)
            }
            
            
        }
        const toDownload = () => {
            router.push({
                "path":"/download"
            })
            return
        }
        return {
            toDownload,
            sendVoiceCode,
            width,obj, submit,sendCodeFn, toggleCheck, btn_active,setPhone,secondRef,btn_text,setCode, back,phoneInput,codeInput,code_text,reviews
        }
    }    
}
</script>
